import { ScraperPicture } from './scraper_picture'

customElements.define('scraper-picture', ScraperPicture)
